import type { CreateBrandDTO } from "@nlc/shared-types";
import type { UseMutationResult } from "@tanstack/react-query";

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { brandsKeys } from "@/hooks/queryKeys";
import apiClient from "@/lib/api/client";

type CreateBrandResponse = {
  id: number;
};

type CreateBrandRequest = {
  data: CreateBrandDTO;
  projectId: number;
};

export function useCreateBrand(): UseMutationResult<
  CreateBrandResponse,
  Error,
  CreateBrandRequest
> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ data, projectId }: CreateBrandRequest) =>
      apiClient
        .url(`/brands/${projectId}`)
        .post(data)
        .json<CreateBrandResponse>(),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: brandsKeys.all,
      });
    },
  });
}
